<template>
  <div
    class="justify-content-between tourHotelSelectHotel_card-hotel hotel_list_frame"
  >
    <div class="hotel_list_img">
      <figure>
        <img
          v-if="displaySingleImage"
          :src="viewImagePath"
          alt="hotel image"
          class="tourHotelSelectHotel_card-image"
          @error="imageLoadFailed = true"
        />
        <tk-image-swiper
          v-else
          :image-list="images"
          :swiper-options="swiperOption"
          class="swiper-container"
          @enter="enterImageSwiper"
          @leave="leaveImageSwiper"
        />
      </figure>
      <div class="hotel_list_img_fixed_area">
        <div class="tourHotelSelectHotel_card-hotel_info_name">
          {{ name }}
        </div>
        <div class="tourHotelSelectHotel_card-hotel_info_detail_area">
          <div class="tourHotelSelectHotel_card-hotel_info_detail_location">
            {{ city }}
          </div>
          <tk-star-rating
            text-class="tourHotelSelectHotel_card-hotel_info_detail_star"
            :star-number="starNumber"
          />
        </div>
      </div>
      <span v-if="isTourFree && isGoto" class="icon_goto">
        <img
          src="https://www.tabikobo.com/japan/images/label_goto.svg"
          alt="GOTO対象"
        />
      </span>
    </div>
    <div class="tourHotelSelectHotel_card-hotel_info">
      <div class="tourHotelSelectHotel_card-hotel_info_name">
        {{ name }}
      </div>
      <div
        class="tourHotelSelectHotel-flex-pc tourHotelSelectHotel_card-hotel_info_detail"
      >
        <div>
          <tk-star-rating
            class="tourHotelSelectHotel_card-hotel_info_detail_star"
            text-class="tourHotelSelectHotel_card-hotel_info_detail_star"
            :star-number="starNumber"
          />
          <div class="tourHotelSelectHotel_card-hotel_info_detail_location">
            {{ city }}
          </div>
          <div
            v-if="guestRatings"
            class="tourHotelSelectHotel_card-hotel_info_guest_review"
          >
            <b class="txt_rv">口コミ</b>
            <span class="ratingScore">{{ guestRatings.OVERALL }}</span>
            <b>/5</b>
            <span class="total_review">({{ guestRatings.COUNT }}件)</span>
          </div>
          <tk-tripadvisor-rating
            v-if="displayTripAdvisor"
            :review-count="tripadvisorInfo.reviewCount"
            :rating-image-url="tripadvisorInfo.ratingImageUrl"
            :rating-value="tripadvisorInfo.ratingValue"
            @clicked="$emit('tripadvisor-clicked')"
          />
        </div>

        <div class="tourHotelSelectHotel_card-hotel_info_detail_latter_half">
          <tk-hotel-card-price
            v-if="showPrice"
            :is-goto="isGoto"
            :passenger-number="passengerNumber"
            :night-number="nightNumber"
            :current-price="currentPrice"
            :goto-price="gotoPrice"
            :previous-price="previousPrice"
            :is-tour-free="isTourFree"
          />
          <!-- SP -->
          <div>
            <tk-link @click.prevent="onClicked"></tk-link>
          </div>
          <!-- PC -->
          <div class="tourHotelSelectHotel_card-hotel_info_select_btn-pc">
            <button type="button" @click.prevent="onClicked">
              このホテルを選択する
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TkLink from '../../atoms/TkLink/TkLink'
import TkStarRating from '../../atoms/TkStarRating/TkStarRating'
import TkHotelCardPrice from '../../widgets/TkHotelCardPrice/TkHotelCardPrice.vue'
import TkTripadvisorRating from '../../widgets/TkTripadvisorRating/TkTripadvisorRating.vue'
import TkImageSwiper from '../../atoms/TkImageSwiper/TkImageSwiper.vue'

export default {
  name: 'TkHotelCard',
  components: {
    TkHotelCardPrice,
    TkLink,
    TkStarRating,
    TkTripadvisorRating,
    TkImageSwiper,
  },
  props: {
    city: { type: String, required: true },
    images: { type: Array, default: () => [] },
    code: { type: String, required: true },
    name: { type: String, required: true },
    passengerNumber: { type: Number, required: true },
    nightNumber: { type: Number, required: true },
    isGoto: { type: Boolean, default: false },
    currentPrice: { type: String, default: '' },
    gotoPrice: { type: String, default: '' },
    previousPrice: { type: String, default: '' },
    starNumber: { type: Number, default: 0 },
    tripadvisorInfo: { type: Object, default: null },
    showPrice: { type: Boolean, default: false },
    isTourFree: { type: Boolean, default: false },
    guestRatings: { type: Object, default: null },
  },
  data() {
    return {
      imageLoadFailed: false,
      swiperOption: {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 500,
          disableOnInteraction: false,
          initState: 'stop',
        },
        loop: true,
      },
    }
  },
  computed: {
    viewImagePath() {
      let viewImagePath = ''
      if (this.images && this.images.length > 0) {
        viewImagePath = this.images[0]
      }
      if (!viewImagePath || this.imageLoadFailed) {
        viewImagePath = require('@ota-frontend/shared-assets/images/common/noimage.jpg')
      }
      return viewImagePath
    },
    displaySingleImage() {
      return screen.width <= 657 || (this.images && this.images.length <= 1)
    },
    displayTripAdvisor() {
      return (
        this.tripadvisorInfo &&
        Object.keys(this.tripadvisorInfo).length > 0 &&
        ((screen.width <= 657 && !this.isGoto) || screen.width > 657)
      )
    },
  },
  methods: {
    onClicked() {
      this.$emit('item-clicked', this.code)
    },
    enterImageSwiper({ container }) {
      container.$swiper.autoplay.start()
    },
    leaveImageSwiper({ container }) {
      container.$swiper.autoplay.stop()
    },
  },
}
</script>
